import styled from "styled-components";
import { spacing, typographyMixin } from "@magicbi/ui-library";

export const Bar = styled.div`
  display: flex;
  align-items: center;
  gap: ${spacing[4]};
  padding: ${spacing[2]} ${spacing[3.5]};
  background: ${({ theme }) => theme.colors.background.tertiary};
  color: ${({ theme }) => theme.colors.text.primary};
  ${typographyMixin("caption", 3)}
  font-weight: 600;
`;

export const Spacer = styled.span`
  flex: 1;
`;

export const BarButton = styled.button<{ $quiet?: boolean }>`
  padding: 0;
  border: 0;
  background: none;
  color: ${({ $quiet, theme }) => ($quiet ? theme.colors.text.secondary : theme.colors.text.link)};
  font: inherit;
  cursor: pointer;

  &:hover:not(:disabled) {
    text-decoration: underline;
  }
  &:disabled {
    color: ${({ theme }) => theme.colors.text.disabled};
    cursor: not-allowed;
  }
  &:focus-visible {
    outline: 2px solid ${({ theme }) => theme.colors.interactive.primary};
    outline-offset: 2px;
  }
`;
